<template>
  <div class="WebApplicationFirewallMonitorSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="4">
          <!--账户名称 -->
          <Input
            v-model="accountName"
            :placeholder="$t('alarms.common.filterByAccountName')"
          />
        </Col>
        <Col span="4">
          <Button
            type="primary"
            v-hasPermission="['monitor:WebApplicationFirewallMonitor:page']"
            @click="getData"
            >{{ $t("message.select") }}</Button
          >
        </Col>
      </div>
    </Row>
  </div>
</template>
<script>
import TableWebApplicationFirewall from "../webApplicationFirewall/TableWebApplicationFirewall";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import {
  CLOUD_PLATFORM_ID,
  buildPlatformOptions
} from "../../../utils/cloudPlatform.js";
var tableWebApplicationFirewall = TableWebApplicationFirewall;
export default {
  name: "WebApplicationFirewallMonitorSearch",
  data() {
    return {
      accountName: "",
      accountType: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountTypeList: buildPlatformOptions([
        CLOUD_PLATFORM_ID.AWS,
        CLOUD_PLATFORM_ID.ALIYUN,
        CLOUD_PLATFORM_ID.AZURE,
        CLOUD_PLATFORM_ID.VMWARE,
        CLOUD_PLATFORM_ID.GCP
      ])
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      tableWebApplicationFirewall.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.WebApplicationFirewallMonitorSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/webApplicationFirewall/WebApplicationFirewallMonitorSearch.vue